<template>
  <div id="Preview">
    <!-- <Head /> -->
    <div class="preview">
      <div class="index">
        <div class="cover">
          <p class="title">{{sbbYear}}年煤炭企业管理现代化创新成果</p>
          <p class="name">申报表</p>
          <div>
            <p>成果名称：{{arr.cgmc}}</p>
            <p>申报单位：{{arr.sbdw}}</p>
          </div>
          <p class="footer">中国煤炭工业协会</p>
        </div>
      </div>
      <table border="1" cellspacing="0">
        <tr>
          <td>成果分类</td>
          <td colspan="3">{{arr.cgfl}}</td>
        </tr>
        <tr>
          <td>成果名称</td>
          <td colspan="3">{{arr.cgmc}}</td>
        </tr>
        <tr>
          <td>申报单位(全称)</td>
          <td colspan="3">{{arr.sbdw}}</td>
        </tr>
        <tr>
          <td>推荐单位(全称)</td>
          <td colspan="3">{{arr.tjdw}}</td>
        </tr>
        <tr>
          <td rowspan="4">
            成果主要创造人
            <p>(最多2人)</p>
          </td>
        </tr>
        <tr>
          <td>姓名</td>
          <td style="font-weight:bold">职务</td>
          <td style="font-weight:bold">职称</td>
        </tr>
        <tr>
          <td style="font-weight:normal">{{arr.csrxm1}}</td>
          <td>{{arr.csrzw1}}</td>
          <td>{{arr.csrzc1}}</td>
        </tr>
        <tr>
          <td style="font-weight:normal">{{arr.csrxm2}}</td>
          <td>{{arr.csrzw2}}</td>
          <td>{{arr.csrzc2}}</td>
        </tr>
        <tr>
          <td rowspan="11">
            成果参与创造人
            <p>(最多10人)</p>
          </td>
        </tr>
        <tr>
          <td style="font-weight:normal">{{arr.cycsrxm1}}</td>
          <td>{{arr.cycsrzw1}}</td>
          <td>{{arr.cycsrzc1}}</td>
        </tr>
        <tr>
          <td style="font-weight:normal">{{arr.cycsrxm2}}</td>
          <td>{{arr.cycsrzw2}}</td>
          <td>{{arr.cycsrzc2}}</td>
        </tr>
        <tr>
          <td style="font-weight:normal">{{arr.cycsrxm3}}</td>
          <td>{{arr.cycsrzw3}}</td>
          <td>{{arr.cycsrzc3}}</td>
        </tr>
        <tr>
          <td style="font-weight:normal">{{arr.cycsrxm4}}</td>
          <td>{{arr.cycsrzw4}}</td>
          <td>{{arr.cycsrzc4}}</td>
        </tr>
        <tr>
          <td style="font-weight:normal">{{arr.cycsrxm5}}</td>
          <td>{{arr.cycsrzw5}}</td>
          <td>{{arr.cycsrzc5}}</td>
        </tr>
        <tr>
          <td style="font-weight:normal">{{arr.cycsrxm6}}</td>
          <td>{{arr.cycsrzw6}}</td>
          <td>{{arr.cycsrzc6}}</td>
        </tr>
        <tr>
          <td style="font-weight:normal">{{arr.cycsrxm7}}</td>
          <td>{{arr.cycsrzw7}}</td>
          <td>{{arr.cycsrzc7}}</td>
        </tr>
        <tr>
          <td style="font-weight:normal">{{arr.cycsrxm8}}</td>
          <td>{{arr.cycsrzw8}}</td>
          <td>{{arr.cycsrzc8}}</td>
        </tr>
        <tr>
          <td style="font-weight:normal">{{arr.cycsrxm9}}</td>
          <td>{{arr.cycsrzw9}}</td>
          <td>{{arr.cycsrzc9}}</td>
        </tr>
        <tr>
          <td style="font-weight:normal">{{arr.cycsrxm10}}</td>
          <td>{{arr.cycsrzw10}}</td>
          <td>{{arr.cycsrzc10}}</td>
        </tr>
        <tr>
          <td>申报单位类型(注2)</td>
          <td colspan="3">{{arr.sbdwlx}}</td>
        </tr>
        <tr>
          <td>申报单位规模(注3)</td>
          <td colspan="3">{{arr.sbdwgm}}</td>
        </tr>
        <tr>
          <td>申报单位详细地址</td>
          <td colspan="3">{{arr.sbdwdz}}</td>
        </tr>
      </table>
      <table border="1" cellspacing="0">
        <tr>
          <td>电子邮箱</td>
          <td colspan="3">{{arr.dzyx}}</td>
          <td style="font-weight:bold">邮编</td>
          <td>{{arr.yb}}</td>
        </tr>
        <tr>
          <td rowspan="2">申报联系人</td>
          <td>姓名</td>
          <td>职务</td>
          <td>电话</td>
          <td>手机</td>
          <td>传真</td>
        </tr>
        <tr>
          <td style="font-weight:normal">{{arr.sblxrxm}}</td>
          <td>{{arr.sblxrzw}}</td>
          <td>{{arr.sblxrdh}}</td>
          <td>{{arr.sblxrsj}}</td>
          <td>{{arr.sblxrcz}}</td>
        </tr>
      </table>
      <table border="1" cellspacing="0">
        <tr>
          <td colspan="2">
            <div>
              <p class="title"></p>
              <p>
                (请对
                <b>成果来源、成果内涵、主要创新点和示范作用</b>作1000字以内的简要介绍)
              </p>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <div>
              <p>一、成果来源</p>
              <div>{{arr.cgly}}</div>
            </div>
            <div>
              <p>二、成果内涵</p>
              <div>{{arr.cgnh}}</div>
            </div>
            <div>
              <p>三、主要创新点</p>
              <div>{{arr.zycxd}}</div>
            </div>
            <div>
              <p>四、示范作用</p>
              <div>{{arr.sfzy}}</div>
            </div>
          </td>
        </tr>
        <tr>
          <td>本成果何时经过何单位、何种鉴定，或何奖项（注4）</td>
          <td>{{arr.cgsyjl}}</td>
        </tr>
      </table>
      <table border="1" cellspacing="0">
        <tr>
          <td colspan="6" class="title">成果经济效益指标测算结果(注5)</td>
        </tr>
        <tr>
          <td>成果创造时间</td>
          <td colspan="2">{{arr.cgczsjn}}年 {{arr.cgczsjy}}月</td>
          <td>成果应用年限</td>
          <td colspan="2">{{arr.cgyynx}}年</td>
        </tr>
        <tr>
          <td>成果实施范围</td>
          <td colspan="5">{{arr.cgssfw}}</td>
        </tr>
        <tr>
          <td>成果效益计算方法及公式</td>
          <td colspan="5">
            <div v-html="arr.cgxyjs"></div>
          </td>
        </tr>
        <tr>
          <td>序号</td>
          <td>指标名称</td>
          <td>计量单位</td>
          <td>时间</td>
          <td>测算结果</td>
          <td>备注</td>
        </tr>
        <tr>
          <td style="font-weight:normal">1</td>
          <td>申报前一年效益额</td>
          <td>万元</td>
          <td>{{sbbYear-1}}年</td>
          <td>{{arr.sbqynxye}}</td>
          <td>{{arr.sbqynxyebz}}</td>
        </tr>
        <tr>
          <td style="font-weight:normal">2</td>
          <td>实施各年累计效益额</td>
          <td>万元</td>
          <td>{{arr.ssgn1}}年至 {{arr.ssgn2}}年共 {{arr.ssgnzn}}年</td>
          <td>{{arr.ssgnljxye}}</td>
          <td>{{arr.ssgnljxyebz}}</td>
        </tr>
        <tr>
          <td style="font-weight:normal">3</td>
          <td>平均年度效益额</td>
          <td>万元</td>
          <td>{{arr.pjndxyen1}}年至 {{arr.pjndxyen2}}年共 {{arr.pjndxyezn}}年</td>
          <td>{{arr.pjndxye}}</td>
          <td>{{arr.pjndxyebz}}</td>
        </tr>
        <tr>
          <td style="font-weight:normal">4</td>
          <td>申报前一年效益贡献额</td>
          <td>%</td>
          <td>{{sbbYear-1}}年</td>
          <td>{{arr.sbqyngxl}}</td>
          <td>{{arr.sbqyngxlbz}}</td>
        </tr>
      </table>
      <!-- <table border="1" cellspacing="0">
        <tr>
          <td colspan="2" class="title">申报单位主要指标(注6)</td>
        </tr>
        <tr>
          <td colspan="2" class="title">审核意见</td>
        </tr>
        <tr>
          <td style="width:50%">
            <div>
              <p class="top">本单位财务部门审核意见</p>
              <span>盖章</span>
              <p>年 月 日</p>
            </div>
          </td>
          <td>
            <div>
              <p class="top">法定代表人确认签字</p>
              <span>盖章</span>
              <p>年 月 日</p>
            </div>
          </td>
        </tr>
        <tr>
          <td style="text-align:center">推荐单位初审意见</td>
          <td>
            <div>
              <span>盖章</span>
              <p>年 月 日</p>
            </div>
          </td>
        </tr>
        <tr>
          <td style="text-align:center">中国煤炭工业协会审定意见</td>
          <td>
            <div>
              <span>盖章</span>
              <p>年 月 日</p>
            </div>
          </td>
        </tr>
      </table>-->

      <!-- 财务统计指标 -->
      <table border="1" cellspacing="0" v-if="t!=1">
        <tr>
          <td colspan="2" class="title">财务统计指标</td>
        </tr>
        <tr style="font-weight:bold">
          <td style="width:40%">主要指标</td>
          <td>{{sbbYear-1}}年度</td>
        </tr>
        <tr v-for="(item,index) in finance" :key="index">
          <td style="font-weight:normal">{{item.Name}}</td>
          <td>{{item.Content}}</td>
          <!-- <td v-if="Content">{{item.Content}}</td> -->
        </tr>
      </table>
      <!-- 专业统计指标 -->
      <table border="1" cellspacing="0" v-if="t!=1&&property!=10&&property!==null">
        <tr>
          <td colspan="2" class="title">专业统计指标</td>
        </tr>
        <tr style="font-weight:bold">
          <td style="width:40%">主要指标</td>
          <td>{{sbbYear-1}}年度</td>
        </tr>
        <tr v-for="(item,index) in major" :key="index">
          <td style="font-weight:normal">{{item.Name}}</td>
          <td>{{item.Content}}</td>
          <!-- <td>{{Content1[index].value}}</td> -->
        </tr>
      </table>
    </div>
    <!-- <Foot /> -->
  </div>
</template>
<script>
// import Head from "../../components/Head";
// import Foot from "../../components/Foot";
export default {
  name: "tableList",
  data() {
    return {
      ReportID: "",
      result: [],
      arr: {},
      t: "",
      finance: [], //财务指标
      major: [], //专业指标
      // Content: [],
      // Content1: [],

      cgmc: "",
      sbdw: "",
      property: "",
    };
  },
  props: ["yulan", "CompanyID","sbbYear"],
  components: {
    // Head,
    // Foot
  },
  // computed:{
  //   year(){
  //     var time=new Date()
  //     return time.getFullYear()
  //   }
  // },
  created() {
    this.result = JSON.parse(this.yulan);
    console.log(this.result);

    // console.log(this.$route.query.table);
    // if (sessionStorage.getItem("isListGo") == "true") {
    //   this.ReportID = sessionStorage.getItem("reportID");
    // } else {
    //   this.ReportID = sessionStorage.getItem("ReportID");
    // }
    // console.log(this.ReportID);
    // this.getData()
    this.result.forEach(val => {
      
      this.arr = Object.assign(this.arr, this.toObj2(val.Title, val.Content));
    });
    console.log(this.arr);
  },
  mounted() {
    this.t = sessionStorage.getItem("t");
    console.log(this.t, "type");
    var id = JSON.parse(sessionStorage.getItem("userinfo")).ID;
    if (this.t != 1) {
      this.$axios
        .post(
          "company/info",
          this.$qs.stringify({
            ID: id,
            token: sessionStorage.getItem("token")
          })
        )
        .then(res => {
          if (res.data.code == 10000) {
            this.property = res.data.data.Property;
          } else if (res.data.code == 10002) {
            this.$message({
              type: "warning",
              message: res.data.msg
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    }
    this.getInfo();
  },
  methods: {
    toObj2(key, val) {
      var data = { [key]: val };
      return data;
    },
    // getData() {
    //   let that = this;
    //   that.$axios
    //     .post(
    //       that.$URL +
    //         "/reportcontent/info?ReportID=" +
    //         that.ReportID +
    //         "&token=" +
    //         sessionStorage.getItem("token")
    //     )
    //     .then(function(res) {
    //       console.log(res.data.data);

    //       // this.result=res.data.data
    //     });
    // },
    getData() {
      // let that =this;
      // that.$axios.post("statistic/companyStatistic",)
      console.log(this.yulan);
    },
    getInfo() {
      let that = this;
      if (that.t != 1) {
        that.$axios
          .post(
            "statistic/companyStatistic?token=" +
              sessionStorage.getItem("token") +
              "&ID=" +
              that.CompanyID+"&year="+that.sbbYear
          )
          .then(res => {
            console.log(res.data.data, "info");
            if (res.data.code == 10000) {
              that.finance = res.data.data.slice(0, 13);
              that.major = res.data.data.slice(13, res.data.data.length);
              console.log(that.finance);
              console.log(that.major);
            } else if (res.data.code == 10002) {
              this.$message({
                type: "warning",
                message: res.data.msg
              });
            } else {
              // this.$message.error(res.data.msg);
            }
          });
      }
    }
    // async getNumber() {
    //   let that = this;
    //   await that.$axios
    //     .post(
    //       that.$URL +
    //         "/StatisticContent/index?StatisticID=" +
    //         that.StatisticID +
    //         "&token=" +
    //         sessionStorage.getItem("token")
    //     )
    //     .then(res => {
    //       if (res.data.code == 10000) {
    //         console.log(res.data.data, "n");
    //         if (res.data.data.list.length == 0) {
    //           for (var i1 = 0; i1 < that.Content.length; i1++) {
    //             that.Content[i1]["value"] = "";
    //           }
    //         } else {
    //           for (var i = 0; i < res.data.data.list.length; i++) {
    //             that.Content[i]["value"] = res.data.data.list[i]["Content"];
    //           }
    //         }
    //       } else {
    //         this.$message({
    //           message: res.data.msg,
    //           type: "warning"
    //         });
    //       }
    //     });
    // },
    // getNumber1() {
    //   let that = this;
    //   that.$axios
    //     .post(
    //       that.$URL +
    //         "/StatisticContent/index?StatisticID=" +
    //         that.StatisticID1 +
    //         "&token=" +
    //         sessionStorage.getItem("token")
    //     )
    //     .then(res => {
    //       if (res.data.code == 10000) {
    //         console.log(res.data.data, "n1111");
    //         if (res.data.data.list.length == 0) {
    //           for (var j1 = 0; j1 < that.Content1.length; j1++) {
    //             that.Content1[j1]["value"] = "";
    //           }
    //         } else {
    //           for (var j = 0; j < res.data.data.list.length; j++) {
    //             this.Content[j]["value"] = res.data.data.list[j]["Content"];
    //           }
    //         }
    //       } else {
    //         this.$message({
    //           message: res.data.msg,
    //           type: "warning"
    //         });
    //       }
    //     });
    // }
  }
};
</script>
<style lang="less" scoped>
#Preview {
  width: 100%;
  // min-width: 1000px;
  .preview {
    padding-bottom: 0.5rem;
    margin-top: 0.7rem;
    .index {
      width: 80%;
      margin: 0 auto;
      .cover {
        margin-top: 0.5rem;
        text-align: center;
        .title {
          font-size: 0.4rem;
        }
        .name {
          font-size: 0.6rem;
          font-weight: bold;
          margin-top: 1rem;
        }
        div {
          font-size: 0.3rem;
          text-align: left;
          margin-top: 3rem;
          p {
            margin-bottom: 0.3rem;
          }
        }
        .footer {
          font-size: 0.27rem;
          margin: 1.5rem 0 1.8rem;
        }
      }
    }
    table {
      width: 80%;
      margin: 0 auto;
      font-size: 0.24rem;
      text-align: center;
      td {
        padding: 0.15rem 0.1rem;
        word-wrap: break-word;
        word-break: break-all;
        overflow: hidden;
      }
      tr td:first-child {
        width: 20%;
        font-weight: bold;
      }
      p {
        font-weight: normal;
        font-size: 0.22rem;
      }
    }
    table:not(:nth-of-type(1)) {
      border-top: 0;
    }
    table:nth-of-type(2) {
      tr:nth-of-type(2) td {
        font-weight: bold;
      }
    }
    .title {
      font-weight: bold;
      font-size: 0.26rem;
    }
    table:nth-of-type(3) {
      tr:not(:first-of-type) {
        div {
          min-height: 3rem;
          text-align: left;
          p {
            font-weight: bold;
          }
          div {
            font-weight: normal;
            width: 100%;
            word-wrap: break-word;
            word-break: break-all;
            overflow: hidden;
          }
        }
      }
    }
    table:nth-of-type(4) {
      tr:nth-of-type(2),
      tr:nth-of-type(5) {
        font-weight: bold;
      }
    }
    // table:nth-of-type(5) {
    //   tr td {
    //     font-weight: normal;
    //     text-align: right;
    //     div {
    //       padding: 0 0.2rem;
    //       .top {
    //         text-align: left;
    //       }
    //       span {
    //         display: block;
    //         margin-right: 0.5rem;
    //         margin-top: 0.7rem;
    //       }
    //     }
    //   }
    //   .title {
    //     font-weight: bold;
    //     text-align: center;
    //   }
    // }
  }
}
</style>